import React from 'react';
import styled from 'styled-components';

import { StandaloneChargesTab } from '../types';

type Props = {
  activeTab: StandaloneChargesTab;
  onChange: (tab: StandaloneChargesTab) => void;
};

const TabsWrapper = styled.nav`
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0 0 18px;
  overflow-x: auto;
`;

const TabButton = styled.button`
  min-width: 168px;
  height: 42px;
  padding: 0 22px;
  border: 1px solid transparent;
  border-radius: 4px;
  background-color: transparent;
  color: #686c75;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;

  &[aria-selected='true'] {
    background-color: ${props => props.theme.main.color};
    color: #ffffff;
  }

  &:hover,
  &:focus {
    color: ${props => props.theme.main.color};
    outline: none;
  }

  &[aria-selected='true']:hover,
  &[aria-selected='true']:focus {
    color: #ffffff;
  }

  &:focus-visible {
    border-color: ${props => props.theme.main.color};
    box-shadow: 0 0 0 2px rgba(133, 78, 224, 0.18);
  }

  @media (max-width: 480px) {
    min-width: 142px;
    height: 46px;
    padding: 0 16px;
    font-size: 14px;
  }
`;

const ChargesTabs: React.FC<Props> = ({ activeTab, onChange }) => {
  return (
    <TabsWrapper aria-label="Alternar listas de cobranças" role="tablist">
      <TabButton
        role="tab"
        type="button"
        aria-selected={activeTab === 'sent'}
        onClick={() => onChange('sent')}
      >
        Enviadas
      </TabButton>
      <TabButton
        role="tab"
        type="button"
        aria-selected={activeTab === 'commissioning'}
        onClick={() => onChange('commissioning')}
      >
        Comissionamento
      </TabButton>
    </TabsWrapper>
  );
};

export default ChargesTabs;
